import './DsRoot.scss';
import React from 'react';

import { cn } from 'src/component/ds/utils';
import { useDsThemeClass } from 'src/component/ds/DsTheme';

/** Exported so portal-based components can apply it to their portal content. */
export const DS_ROOT_CLASS = 'ds-root';

/** Stacks portalled popups above the v1 chrome. See DsRoot.scss. */
export const DS_PORTAL_CLASS = 'ds-root-portal';

/** One layer above DS_PORTAL_CLASS, so toasts clear an open dialog. */
export const DS_TOAST_PORTAL_CLASS = 'ds-toast-portal';

/**
 * Same as DsRoot, for popups. Radix renders dialogs, tooltips, dropdowns and
 * selects onto document.body, outside DsRoot, so they lose the DS styles --
 * this puts them back.
 *
 * forwardRef because Radix passes a ref down to it.
 */
export const DsThemedPortal = React.forwardRef<
  HTMLDivElement, { children?: React.ReactNode; className?: string }
>(({ children, className }, ref) => {
  const themeClass = useDsThemeClass();

  return <div ref={ref} className={cn(DS_ROOT_CLASS, DS_PORTAL_CLASS, themeClass, className)}>{children}</div>;
});
DsThemedPortal.displayName = 'DsThemedPortal';

export interface DsRootProps {
  children?: React.ReactNode;
  className?: string;
}

/** Every design-system surface must render inside this. */
export default function DsRoot ({ children, className }: DsRootProps) {
  const themeClass = useDsThemeClass();

  return (
    <div className={cn(DS_ROOT_CLASS, themeClass, className)} data-testid='ds-root'>{children}</div>
  );
}
